import React, { useEffect, useState } from 'react';

function MuroPage() {

  // ==========================================
  // URL DE LA API
  // ==========================================

  const API_URL = 'https://marketluz.com/laravel8/public/api/muro';


  // ==========================================
  // ESTADOS
  // ==========================================

  const [comentarios, setComentarios] = useState([]);

  const [nombre, setNombre] = useState('');
  const [nuevoComentario, setNuevoComentario] = useState('');

  const [cargando, setCargando] = useState(true);
  const [enviando, setEnviando] = useState(false);

  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');


  // ==========================================
  // CARGAR COMENTARIOS DESDE MYSQL
  // ==========================================

  const cargarComentarios = async () => {

    try {

      setCargando(true);
      setError('');

      const response = await fetch(API_URL);

      if (!response.ok) {
        throw new Error('No se pudieron cargar los comentarios.');
      }

      const data = await response.json();

      setComentarios(data);

    } catch (error) {

      console.error('Error al cargar comentarios:', error);

      setError(
        'No se pudieron cargar los comentarios del muro.'
      );

    } finally {

      setCargando(false);

    }
  };


  // ==========================================
  // CARGAR AL ABRIR LA PÁGINA
  // ==========================================

  useEffect(() => {

    cargarComentarios();

  }, []);


  // ==========================================
  // AGREGAR COMENTARIO
  // ==========================================

  const handleAgregarComentario = async (e) => {

    e.preventDefault();

    setMensaje('');
    setError('');


    // ==========================================
    // VALIDACIONES
    // ==========================================

    const nombreLimpio = nombre.trim();
    const comentarioLimpio = nuevoComentario.trim();

    if (!nombreLimpio || !comentarioLimpio) {

      setError(
        'Por favor coloca tu nombre y tu comentario.'
      );

      return;
    }


    // ==========================================
    // ENVIAR A LARAVEL
    // ==========================================

    try {

      setEnviando(true);

      const response = await fetch(API_URL, {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          nombre: nombreLimpio,
          comentario: comentarioLimpio
        })

      });


      // ==========================================
      // LEER RESPUESTA
      // ==========================================

      const data = await response.json();


      if (!response.ok) {

        throw new Error(
          data.message ||
          'No se pudo publicar el comentario.'
        );

      }


      // ==========================================
      // AGREGAR COMENTARIO AL MURO
      // SIN RECARGAR LA PÁGINA
      // ==========================================

      if (data.comentario) {

        setComentarios((comentariosActuales) => [
          data.comentario,
          ...comentariosActuales
        ]);

      }


      // ==========================================
      // LIMPIAR FORMULARIO
      // ==========================================

      setNombre('');
      setNuevoComentario('');

      setMensaje(
        'Tu comentario fue publicado correctamente.'
      );


    } catch (error) {

      console.error(
        'Error al publicar comentario:',
        error
      );

      setError(
        error.message ||
        'Ocurrió un error al publicar el comentario.'
      );


    } finally {

      setEnviando(false);

    }

  };

  // ==========================================
// DAR LIKE A UN COMENTARIO
// ==========================================

const handleLike = async (id) => {

  try {

    const response = await fetch(
      `${API_URL}/${id}/like`,
      {
        method: 'PUT',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.message || 'No se pudo registrar el like.'
      );
    }

    // ==========================================
    // ACTUALIZAR EL LIKE EN PANTALLA
    // SIN RECARGAR LA PÁGINA
    // ==========================================

    setComentarios((comentariosActuales) =>
      comentariosActuales.map((comentario) =>
        comentario.id === id
          ? {
              ...comentario,
              likes: data.likes
            }
          : comentario
      )
    );

  } catch (error) {

    console.error(
      'Error al dar like:',
      error
    );

  }

};









  // ==========================================
  // OBTENER INICIAL DEL NOMBRE
  // ==========================================

  const obtenerInicial = (nombreComentario) => {

    if (!nombreComentario) {
      return '?';
    }

    return nombreComentario
      .trim()
      .charAt(0)
      .toUpperCase();

  };


  // ==========================================
  // FORMATEAR FECHA
  // ==========================================

  const formatearFecha = (fecha) => {

    if (!fecha) {
      return '';
    }

    const partes = fecha.split('-');

    if (partes.length !== 3) {
      return fecha;
    }

    const [anio, mes, dia] = partes;

    return `${dia}/${mes}/${anio}`;

  };


  return (

    <div className="muro-container">


      {/* ==========================================
          ENCABEZADO
      ========================================== */}

      <div className="muro-intro">

        <div className="intro-icon">
          💬
        </div>

        <div>

          <span className="intro-label">
            COMUNIDAD MARKET LUZ
          </span>

          <h1>
            Muro de la comunidad
          </h1>

          <p>
            Un espacio para compartir ideas, deseos, experiencias
            y opiniones con nuestra comunidad.
          </p>

        </div>

      </div>


      {/* ==========================================
          AGREGAR COMENTARIO
      ========================================== */}

      <div className="agregar-comentario-card">

        <div className="agregar-comentario-titulo">

          <div className="agregar-icon">
            ✍️
          </div>

          <div>

            <h2>
              Comparte tu opinión
            </h2>

            <p>
              Cuéntale a la comunidad qué piensas.
            </p>

          </div>

        </div>


        <form onSubmit={handleAgregarComentario}>


          {/* ==========================================
              NOMBRE
          ========================================== */}

          <div
            className="campo-comentario"
            style={{
              width: '100%',
              maxWidth: '720px',
              margin: '0 auto 22px auto'
            }}
          >

            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '600',
                color: '#343a40'
              }}
            >
              Tu nombre
            </label>


            <input
              type="text"
              placeholder="Ej. Juan Pérez"
              value={nombre}
              onChange={(e) =>
                setNombre(e.target.value)
              }
              maxLength="100"
              disabled={enviando}

              style={{
                display: 'block',
                width: '100%',
                height: '48px',
                boxSizing: 'border-box',

                padding: '0 16px',

                border: '1px solid #dde1e7',
                borderRadius: '11px',

                outline: 'none',

                backgroundColor: '#ffffff',

                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '400',
                color: '#212529',

                boxShadow:
                  '0 3px 10px rgba(0, 0, 0, 0.04)',

                transition:
                  'border-color 0.2s ease, box-shadow 0.2s ease'
              }}

              onFocus={(e) => {

                e.target.style.borderColor = '#6c63ff';

                e.target.style.boxShadow =
                  '0 0 0 3px rgba(108, 99, 255, 0.12)';

              }}

              onBlur={(e) => {

                e.target.style.borderColor = '#dde1e7';

                e.target.style.boxShadow =
                  '0 3px 10px rgba(0, 0, 0, 0.04)';

              }}
            />

          </div>


          {/* ==========================================
              COMENTARIO
          ========================================== */}

          <div
            className="campo-comentario"
            style={{
              width: '100%',
              maxWidth: '720px',
              margin: '0 auto 22px auto'
            }}
          >

            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '600',
                color: '#343a40'
              }}
            >
              Tu comentario
            </label>


            <textarea
              placeholder="Escribe aquí tu opinión..."
              value={nuevoComentario}
              onChange={(e) =>
                setNuevoComentario(e.target.value)
              }
              maxLength="500"
              rows="4"
              disabled={enviando}

              style={{
                display: 'block',
                width: '100%',
                minHeight: '125px',
                boxSizing: 'border-box',

                padding: '14px 16px',

                border: '1px solid #dde1e7',
                borderRadius: '11px',

                outline: 'none',

                resize: 'vertical',

                backgroundColor: '#ffffff',

                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '1.6',
                color: '#212529',

                boxShadow:
                  '0 3px 10px rgba(0, 0, 0, 0.04)',

                transition:
                  'border-color 0.2s ease, box-shadow 0.2s ease'
              }}

              onFocus={(e) => {

                e.target.style.borderColor = '#6c63ff';

                e.target.style.boxShadow =
                  '0 0 0 3px rgba(108, 99, 255, 0.12)';

              }}

              onBlur={(e) => {

                e.target.style.borderColor = '#dde1e7';

                e.target.style.boxShadow =
                  '0 3px 10px rgba(0, 0, 0, 0.04)';

              }}
            />

          </div>


          {/* ==========================================
              MENSAJE DE ÉXITO
          ========================================== */}

          {mensaje && (

            <div
              style={{
                width: '100%',
                maxWidth: '720px',
                boxSizing: 'border-box',
                margin: '0 auto 15px auto',
                padding: '10px 12px',
                borderRadius: '8px',
                background: '#e8f7ee',
                color: '#198754',
                fontSize: '13px',
                fontFamily: "'Poppins', sans-serif"
              }}
            >
              {mensaje}
            </div>

          )}


          {/* ==========================================
              MENSAJE DE ERROR
          ========================================== */}

          {error && (

            <div
              style={{
                width: '100%',
                maxWidth: '720px',
                boxSizing: 'border-box',
                margin: '0 auto 15px auto',
                padding: '10px 12px',
                borderRadius: '8px',
                background: '#fdecec',
                color: '#dc3545',
                fontSize: '13px',
                fontFamily: "'Poppins', sans-serif"
              }}
            >
              {error}
            </div>

          )}


          {/* ==========================================
              BOTÓN PUBLICAR
          ========================================== */}

          <div
            style={{
              width: '100%',
              maxWidth: '720px',
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >

            <button
              type="submit"
              disabled={enviando}
              style={{
                background:
                  'linear-gradient(135deg, #6c63ff, #6c63ff)',

                color: '#ffffff',

                border: 'none',
                borderRadius: '10px',

                padding: '11px 22px',

                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '600',

                cursor:
                  enviando
                    ? 'not-allowed'
                    : 'pointer',

                boxShadow:
                  '0 4px 12px rgba(79, 70, 229, 0.20)',

                opacity:
                  enviando
                    ? 0.6
                    : 1,

                transition:
                  'transform 0.2s ease, box-shadow 0.2s ease'
              }}
            >

              {enviando
                ? 'Publicando...'
                : 'Publicar comentario'
              }

            </button>

          </div>

        </form>

      </div>


      {/* ==========================================
          BARRA SUPERIOR
      ========================================== */}

      <div className="muro-toolbar">

        <div>

          <strong>
            Publicaciones recientes
          </strong>

          <span>
            {comentarios.length} comentarios
          </span>

        </div>

        <button className="ordenar-btn">
          Más recientes ▾
        </button>

      </div>


      {/* ==========================================
          CARGANDO
      ========================================== */}

      {cargando && (

        <div
          style={{
            textAlign: 'center',
            padding: '40px',
            color: '#6c757d'
          }}
        >
          Cargando comentarios...
        </div>

      )}


      {/* ==========================================
          MURO VACÍO
      ========================================== */}

      {!cargando &&
        comentarios.length === 0 && (

          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              color: '#6c757d'
            }}
          >
            Todavía no hay comentarios.
            Sé el primero en publicar.
          </div>

        )
      }


      {/* ==========================================
          MURO
      ========================================== */}

      {!cargando && (

        <div className="comentarios-grid">

          {comentarios.map((comentario) => (

            <article
              className="comentario-card"
              key={comentario.id}
            >


              {/* USUARIO */}

              <div className="comentario-header">

                <div className="usuario">

                  <div className="avatar">

                    {obtenerInicial(
                      comentario.nombre
                    )}

                  </div>


                  <div>

                    <div className="nombre">
                      {comentario.nombre}
                    </div>

                    <div className="fecha">

                      {formatearFecha(
                        comentario.fecha
                      )}

                    </div>

                  </div>

                </div>


                <button
                  className="more-btn"
                  type="button"
                >
                  ⋮
                </button>

              </div>


              {/* TEXTO */}

              <p className="comentario-texto">

                {comentario.comentario}

              </p>


              {/* ==========================================
                  FOOTER
              ========================================== */}

              <div className="comentario-footer">

                <button
  className="accion"
  type="button"
  onClick={() => handleLike(comentario.id)}
>
  👍

  <span>
    {comentario.likes ?? 0}
  </span>

</button>


                <button
                  className="accion"
                  type="button"
                >
                  💬

                  <span>
                    Comentar
                  </span>

                </button>


                <button
                  className="accion compartir"
                  type="button"
                >
                  ↗

                  <span>
                    Compartir
                  </span>

                </button>

              </div>

            </article>

          ))}

        </div>

      )}

    </div>

  );

}

export default MuroPage;